<template>
  <PageHeaderLayout :isBack="true">
    <div class="main-page-content">
      <more-tree-table class="table" :colData="colHead" :tableValue="tableValue1"></more-tree-table>
      <el-row class="save-btn-wrapper" v-if="this.$route.query.isExamine">
        <el-button type="primary" size="medium" @click="aduit">审核</el-button>
      </el-row>
      <el-row class="save-btn-wrapper" v-if="this.$route.query.sign == '开票' || this.$route.query.sign == '重新开票'">
        <el-button type="primary" size="medium" @click="uploadInvoice">{{ this.$route.query.sign }}</el-button>
      </el-row>
    </div>
    <!-- 审核 -->
    <ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm" @dialogClose="examineDialogClose" :showButton="showButton">
      <template slot="content">
        <el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="examineRuleForm.status" @change="selectRadio">
              <el-radio label="2">通过</el-radio>
              <el-radio label="3">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="examineRuleForm.status == 3">
            <el-input type="textarea" :rows="4" v-model="examineRuleForm.check_remark" placeholder="请输入驳回原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
    <!-- 开票、重新开票 -->
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose" :showButton="showButton" :checkTitle="checkTitle">
        <template slot="content">
          <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" :label-position="'right'" >
            <el-form-item prop="invoice">
              <template slot="label">
                <div class="mail-title">发票：</div>
              </template>
              <upload-file
                class="invoice-wrapper"
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                @before_upload="beforeUpload"
                :title="'开票信息'"
                :multiple="'true'"
                :multiSelection="true"
                :dir="'invoice'"
                :selectfiles="'importService'"
                :postfiles="'submitImportService'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
            </el-form-item>
          </el-form>
        </template>
      </ModalDialog>
  </PageHeaderLayout>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
import UploadFile from "@/components/UploadFile";
export default {
  components: {
    PageHeaderLayout,
    ModalDialog,
    UploadFile
  },
  watch: {
    "examineRuleForm.status": function(val) {
      if(val) {
        this.examineDialogData.loading = false
      }else {
        this.examineDialogData.loading = true
      }
    }
  },
  data() {
    return {
      colHead: [
      ],
      tableValue1: [
        {
          "1111-1-2": "1",
          "1111-1-3": "2",
          "1111-2-2": "3",
          "1111-2-3": "4",
          "1111-3-2": "5",
        },
      ],
      examineDialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      examineRuleForm: {
        id: '',
        status: '',
        check_remark: ''
      },
      dialogData:{
        visible: false,
        title: '',
        width: '40%',
        loading: false,
        modal: false
      },
      ruleForm: {
        id: '',
        invoiceImg: '',
        invoiceNumber: ''
      },
      showButton: ['cancel'],
      checkTitle: '',
      invoice_imgs: ''
    };
  },
  methods: {
    //审核
    aduit() {
      this.examineDialogData.title = `审核${this.examineRuleForm.id}`
      this.examineDialogData.visible = true
    },
     // 处理审核模态框，确定事件
    examineHandleConfirm() {
      // 调用组件的数据验证方法
      this.invoiceAudit()
      this.examineRuleForm = {}
      this.examineDialogData.visible = false
    },
    examineDialogClose() {
      this.examineRuleForm = {}
      this.examineDialogData.visible = false
    },
    selectRadio() {
      console.log(this.examineRuleForm.status,"ruleForm.status")
      if(this.examineRuleForm.status == 2) {
        this.examineRuleForm.check_remark = ''
      }
    },
    uploadInvoice(){
      this.dialogData.title = '上传开票信息'
      this.checkTitle = '确定'
      this.showTitle = 'upload'
      this.dialogData.visible = true
      this.dialogData.loading = true
    },
     // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.saveInvoiceInFo()
      this.dialogData.visible = false
      this.ruleForm = {}
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.ruleForm = {}
      this.checkTitle = ''
    },
     //保存上传开票信息
    async saveInvoiceInFo() {
      this.invoice_imgs = this.invoice_imgs.split(" ").slice(0,-1)
      let args = {
        invoice_imgs: this.invoice_imgs,
        id: this.ruleForm.id
      }
      let result = await this.$api.uploadInvoiceInfo(args)
      if(result) {
        this.$message.success('保存成功')
        this.$router.push({path:'/invoice_partner'})
      }else {
        this.$message.error('保存失败')
      }
    },

     //上传文件前的回调
    beforeUpload(load_text) {
      console.log("load_text",load_text)
      this.dialogData.loading = true;
    },
     // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename, load_text, title}) {
      console.log("->上传成功....", url, filename, load_text, title);
      this.invoice_imgs += `${url} `
      console.log(this.invoice_imgs,"this.invoice_imgs")
      this.dialogData.loading = false
    },

    //审核数据
    async invoiceAudit() {
      let args = {
        id: this.examineRuleForm.id,
        status: this.examineRuleForm.status,
        check_remark: this.examineRuleForm.check_remark
      }
      let result = this.$api.invoiceAudit(args)
      if(result) {
        this.$message.success('审核成功')
      }else {
        this.$message.error('审核失败')
      }
      setTimeout(() => {
        this.$router.push({path: '/admin_invoice'})
      }, 500)
    },
    //开票管理详情
    async invoiceDetail(id) {
      let args = {id: id}
      var result,category_id = '', category_name = '', category_money = ''
      if(this.$route.query.title == '在线开票') {
        result = await this.$api.getInvoiceView(args)//在线开票
      }
      if(this.$route.query.title == '开票管理') {
        result = await this.$api.getInvoiceManageDetail(args)//开票管理
      }
      if(this.$route.query.title == '开票审核') {
        result = await this.$api.getInvoiceAuditView(args)//开票审核
      }
      if(result) {
        result.category_list.forEach(item => {
          category_id += item.category_id
          category_name += item.category_name + "\n\n\n"
          category_money += item.category_money + "\n\n\n"
        });
        console.log(category_id,category_name,category_money, this.convertCurrency(category_money))
        this.colHead = [
          {
          id: "1111",
          name: "开票单位",
          children: [
            {
              id: "1111-1",
              name: `${ result.channel_name }`,
            },
          ],
        },
        {
          id: "2222",
          name: "购货方名称",
          children: [
            {
              id: "2222-1",
              name: `${ result.invoice_title }`,
            },
          ],
        },
        {
          id: "3333",
          name: "纳税人识别号",
          children: [
            {
              id: "3333-1",
              name: `${ result.taxpayer }`,
            },
          ],
        },
        {
          id: "4444",
          name: "地址、电话",
          children: [
            {
              id: "3333-1",
              name: `${ result.company_address }  ${ result.company_phone }`,
            },
          ],
        },
        {
          id: "5555",
          name: "开户行及账号",
          children: [
            {
              id: "3333-1",
              name: `${ result.company_bank }  ${ result.company_account }`,
            },
          ],
        },
        {
          id: "6666",
          name: "开票类别",
          children: [
            {
              id: "3333-1",
              name: result.invoice_type == 0 ? '普通发票' : '增值税专用发票',
            },
          ],
        },
        {
          id: "7777",
          name: "开票项目",
          children: [
            {
              id: "3333-1",
              name: "税收分类编码",
              children: [
                {
                  id: "2222-1-2",
                  name: "货物名称",
                  children: [
                    {
                      id: "2222-1-2",
                      name: "规格型号",
                      children: [
                        {
                          id: "2222-1-2",
                          name: "数量",
                          children: [
                            {
                              id: "2222-1-2",
                              name: "单价（含税）",
                              children: [
                                {
                                  id: "2222-1-2",
                                  name: "金额（含税）",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              id: "3333-2",
              name: category_name,
              children: [
                {
                  id: "2222-1-2",
                  name: "",
                  children: [
                    {
                      id: "2222-1-2",
                      name: "",
                      children: [
                        {
                          id: "2222-1-2",
                          name: "",
                          children: [
                            {
                              id: "2222-1-2",
                              name: "",
                              children: [
                                {
                                  id: "2222-1-2",
                                  name: `${category_money}(${this.convertCurrency(category_money)})`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "8888",
          name: `发票右下角备注信息: ${result.remark}`,
        },
        {
          id: "9999",
          name: "注明：税务分类编码名称会显示并打印在发票上，请正确填写",
        },
        {
          id: "101010",
          name: `收件地址:${result.receiver_address} 收件人: ${result.receiver_fullname} 手机号: ${result.receiver_phone}`,
        },
        ]
      }
    }
  },
  mounted() {
    if( this.$route.query.id ) {
      this.examineRuleForm.id = this.$route.query.id
      this.ruleForm.id = this.$route.query.id
      this.invoiceDetail(this.$route.query.id)
    }
  }
};
</script>
<style lang="stylus" scoped>
.table
  min-height: 500px
  width: 100%
/deep/.editTable__block
  width:100%!important
/deep/.editTableWrapper
  border: none
/deep/.editTableWrapper
  width: 60%
  margin: 0 auto
/deep/.editTableWrapper table thead tr th
  width:0px!important
  background: #CCE8CF
  border: 1px solid black
  color: #333
/deep/.editTable__block {
  user-select: text
}
/deep/.editTableWrapper {
  user-select: text
}
.save-btn-wrapper
  display: flex
  justify-content: flex-end
  margin-top: 30px
  margin-bottom: 30px
.invoice-wrapper
  margin-left: 55px
</style>